<template>
  <div class="lti-view">
    <lti-content :asset="asset" v-if="asset" :userId="userId" :token="token" :locale="locale"/>
    <div class="loader-block bg-transparent" v-if="!asset">
      <div class="loading">
        <div class="effect-1 effects"></div>
        <div class="effect-2 effects"></div>
        <div class="effect-3 effects"></div>
      </div>
    </div>
  </div>
</template>

<script>

import LtiContent from "@/components/ltiContent/ltiContent.vue";
import axios from "axios";

export default {
  name: "LtiView",
  components: {
    LtiContent
  },
  props: {},
  data() {
    return {
      userId: "",
      token: "",
      locale: "en",
      asset: null
    }
  },
  async mounted() {
    const searchParams = new URLSearchParams(window.location.search)
    const ltik = searchParams.get("ltik");
    const env = searchParams.get("env");
    const locale = searchParams.get("locale");
    if (locale) {
      this.locale = locale;
    }
    if (!ltik) {
      const token = searchParams.get("token");
      let tokenData;
      try {
        tokenData = await this.$axios.get(`https://preprod-lti.embibe.com/embibe-token${env ? `?env=${env}` : ""}`, {headers: {token}})
      } catch(err) {console.log(err)}
      if (!(tokenData && tokenData.data && tokenData.data.token)) {
        this.$router.push("/404");
      } else {
        if (tokenData.data.token) {
          this.token = tokenData.data.token;
        }
        if (tokenData.data.userId) {
          this.userId = tokenData.data.userId;
        }
      }
      console.log(this.userId);
    }
    const {type, id} = this.$route.params;
    this.getAsset(type, id);
  },
  destroyed() {
  },
  methods: {
    getAssetType(variant) {
      let assetType = variant.asset_type;
      if (!assetType) {
        if (variant.coobo_library_link) {
          assetType = "3D";
        } else {
          try {
            assetType = variant.ready_links[0].mime.split("/")[0]
          } catch (err) {
            console.log("no asset type");
          }
        }
      }
      return assetType === "video" ? "animation" : assetType;
    },
    getAsset(type, id) {
      switch (type) {
        case "variant": {
          axios.get(`https://amp-api.embibe.com/variants/${id}`).then(res => {
            const variant = res.data;
            this.asset = {
              asset_type: this.getAssetType(variant),
              variants_data: variant,
            }
          })
          break;
        }
        case "video": {
          this.asset = {
            asset_type: "videos",
            embibeId: id,
            language: this.$route.query.locale
          }
          break;
        }
        default: {
          break;
        }
      }
    }
  }
}

</script>

<style>
.lti-view {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.route-ltiView .the-footer {
  display: none;
}

.route-ltiView #content-area .content-wrapper {
  min-height: 0;
  height: calc(var(--vh, 1vh) * 100);
}

</style>
